import React from 'react';
import { BrowserRouter as Router, Route, Switch, useLocation, Redirect } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { PrivateRoute, AdminRoute } from './components/PrivateRoute';
import { useDarkMode } from './hooks/useDarkMode';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Settings from './pages/Settings';
import ClientProfilePage from './pages/ClientProfilePage';
import ImageUploadPage from './pages/ImageUploadPage';
import ImageProcessingResults from './pages/ImageProcessingResults';
import BugReportsPage from './pages/BugReportsPage';
import WorkflowManagement from './pages/WorkflowManagement';
import WorkflowEditor from './pages/WorkflowEditor';
import ApiManagement from './pages/ApiManagement';
import EbayOAuthCallback from './pages/EbayOAuthCallback';
import BugReportButton from './components/BugReportButton';
import PrivacyPolicy from 'pages/PrivacyPolicy';
import LegalNotice from 'pages/LegalNotice';
import { seoConfig, defaultSeo } from "./seo/seoConfig";
import SEO from "./components/SEO";

function AppSEO() {
  const { pathname } = useLocation();
  const seo = seoConfig[pathname] || defaultSeo;
  return <SEO {...seo} />;
}

const AppContent: React.FC = () => {
  useDarkMode(); // Apply dark mode on every page
  const location = useLocation();
  const isLoginPage = location.pathname === '/';

  return (
    <>
      <AppSEO />
      <Switch>
        <Route path="/" exact component={Login} />
        <AdminRoute path="/dashboard" component={Dashboard} />
        <PrivateRoute path="/settings" component={Settings} />
        <PrivateRoute path="/client-profile" component={ClientProfilePage} />
        <PrivateRoute path="/api-management" component={ApiManagement} />
        <PrivateRoute path="/auth/ebay-token" component={EbayOAuthCallback} />
        <PrivateRoute path="/image-upload" component={ImageUploadPage} />
        <PrivateRoute path="/image-processing" component={ImageProcessingResults} />
        <Route path="/privacy-policy" component={PrivacyPolicy} />
        <Route path="/legal-notice" component={LegalNotice} />
        <AdminRoute path="/bug-reports" component={BugReportsPage} />
        <AdminRoute path="/workflow-management" component={WorkflowManagement} />
        <AdminRoute path="/workflow-editor" component={WorkflowEditor} />
        <Route render={() => <Redirect to="/" />} />
      </Switch>
      {!isLoginPage && <BugReportButton />}
    </>
  );
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-200">
        <Router>
          <AppContent />
        </Router>
      </div>
    </AuthProvider>
  );
};

export default App;